import { Pipe, PipeTransform } from '@angular/core';
import { CompleteMedicalCareStruct } from '../../services/structs/orchestrator-patient/complete-medical-care.struct';
import { PrescriptionStatusEnum } from '../../enum/prescription-status.enum';

@Pipe({
    name: 'filterPrescriptionsSuspension',
    standalone: false
})
export class FilterPrescriptionsSuspensionPipe implements PipeTransform {

  transform(medicalCare: CompleteMedicalCareStruct, isMedicatedSolution: boolean, isHistory: boolean, idCurrentMedicalCare?: number): any[] {
    if(!isMedicatedSolution) {
      return isHistory ? 
        medicalCare.listInternalPrescription.filter(x => x.prescriptionMedicine.idPrescriptionStatus == PrescriptionStatusEnum.Suspenso && x.prescriptionMedicine.idMedicalCareSuspended == idCurrentMedicalCare)
        : medicalCare.listInternalPrescription.filter(x => x.canSuspend);
    }
    if(isMedicatedSolution) {
      return isHistory ? 
      medicalCare.listPrescriptionSolution.filter(x => x.idPrescriptionStatus == PrescriptionStatusEnum.Suspenso && x.idMedicalCareSuspended == idCurrentMedicalCare) 
      : medicalCare.listPrescriptionSolution.filter(x => x.canSuspend);
    }
  }
}

